import { Routes, Route } from "react-router-dom";
import { useEffect, useState } from "react";
import DMS from "../Pages/DMS/DMS";
import {
  planning_routes_regs,
  lms_routes_regs,
  configurations,
  contact_management,
  my_tasks_regs,
  region_routes_regs,
  my_gis_mgmnt_regs,
  branches_routes_regs,
  incidents,
  information_center,
  grievance_routes,
  add_atm,
  Dashboard_Dynamic,
  Dashboard_DynamicForApi,
  RoutePlanning,
  FaceManagement,
  OTA,
} from "./DMSRoutes";

import RegistrationManagement from "../Pages/DMS/RegistrationManagement/RegistrationManagement";
import RegionManagement from "../Pages/DMS/RegionManagement/RegionManagement";
import UserManagement from "../Pages/DMS/UserManagement/UserManagement";
import PrivateRoute from "./PrivateRoute";
import ResourceManagement from "../Pages/DMS/ResourceManagement/ResourceManagement";
import MyTaskListManagement from "../Pages/DMS/MyTaskListManagement/MyTaskListManagement";
import { getData } from "../Services/Services";
import {
  getStoredFormTemplates,
  findPermissionsByUser,
  getThemeURL,
} from "../Services/EndPoints";
import SoPManagement from "../Pages/DMS/SOPManagement/SOPManagement";
import ContactManagement from "../Pages/DMS/ContactManagement/ContactManagement";
import { useKeycloak } from "@react-keycloak/web";
import UserTaskManagement from "../Pages/DMS/UserTaskManagement/UserTaskManagement";
import UserTaskForm from "../Pages/DMS/UserTaskManagement/UserTaskForm/UserTaskForm";
import UserProfile from "../Pages/UserProfile/UserProfile";
import RTIncidentDashboard from "../Pages/DMS/GisManagement/RTIncidentDashboard";
import GrievanceMain from "../Pages/DMS/HelpdeskOrGrievance/GrievanceMain";
import GisMain from "../Pages/DMS/GisManagement/GisMain";
import UserViewmain from "../Pages/DMS/UserTaskManagement/UserView/UserViewmain";
import QueryBuilder from "../Pages/DMS/DynamicDashboards/queryBuilderForDashboards";
import EnhancedDashboardManager from "../Pages/DMS/DynamicDashboards/DashboardBuilder";
import EnhancedDashboardManagerForUser from "../Pages/DMS/DynamicDashboards/DashboardBuilderForUser";
import AllincidentsMain from "../Pages/DMS/IncidentManagement/AllIncidents/AllIncidentsMain";
import { toast } from "react-toastify";
import GpsTracking from "../Pages/DMS/GpsTrackManagement/GpsTracking";
import GpsTrackView from "../Pages/DMS/GpsTrackManagement/GpsTrackView";
import ExpectedTrackHeader from "../Pages/DMS/ExpectedTrackForm/ExpectedTrackHeader";
import CreateVehicleHeader from "../Pages/DMS/ExpectedTrackForm/CreateVehicleHeader";

// import EnhancedDashboardManagerForApi from "../Pages/DMS/DynamicDashboardsForApi/DashboardBuilder";
// import EnhancedDashboardManagerForUserForApi from "../Pages/DMS/DynamicDashboardsForApi/DashboardBuilderForUser";
import ApiBuilder from "../Pages/DMS/DynamicDashboardsForApi/ApiBuilder";
import PlannedHeader from "../Pages/DMS/PlannedRoute/PlannedHeader";
import PlannedViewHeader from "../Pages/DMS/PlannedRoute/PlannedViewHeader";
import GpsTravelViewHeader from "../Pages/DMS/PlannedRoute/GpsTravelViewHeader";
import DeviationRouteHeader from "../Pages/DMS/GeoFence/DeviationRouteHeader";
import TripTrackerHeader from "../Pages/DMS/GpsTrackManagement/TripTrackManagement/TripTrackerHeader";
import TripActionHeader from "../Pages/DMS/GpsTrackManagement/TripTrackManagement/TripActionHeader";
import navLinks from "../JsonData/navLinksData";
import BankManagement from "../Pages/DMS/Banks/BankList/BankManagement";
import BankForm from "../Pages/DMS/Banks/AddBankForm/BankForm";
import BranchForm from "../Pages/DMS/Branches/AddBranchForm/BranchForm";
import AllBranches from "../Pages/DMS/Branches/Branches";
import AddAtmForm from "../Pages/DMS/Atms/AddAtm/AddAtmForm";
import AllAtm from "../Pages/DMS/Atms/AllAtms/AllAtm";
import DistrictWiseBranchesMain from "../Pages/DMS/Branches/DistrictWiseBranchesMain";
import DistrictWise from "../Pages/DMS/Atms/DistrictWiseAtms/DistrictWise";
import IncidentForm from "../Pages/DMS/IncidentManagement/AddIncidentForm/IncidentForm";
import AllIncidentsMain from "../Pages/DMS/IncidentManagement/AllIncidents/AllIncidentsMain";
import SOPManagement from "../Pages/DMS/SOPManagement/SOPManagement";
import { TaskManagement } from "../Components/IconComponents";
import ExecuteSops from "../Pages/DMS/SOPManagement/ExecuteSops";
import CreateSOP from "../Pages/DMS/SOPManagement/CreateSOP/CreateSOP";
import AnnouncementsForm from "../Pages/DMS/InformationCenter/NewAnnouncements/AnnouncementsForm";
import DocumentRepoMain from "../Pages/DMS/InformationCenter/DocumentRepository/DocumentRepoMain";
import PublicAnnoncementsMain from "../Pages/DMS/InformationCenter/PublicAnnoncements/PublicAnnoncementsMain";
import RoleManagement from "../Pages/DMS/RoleManagement/RoleManagement";
import RaiseTicketMain from "../Pages/DMS/HelpdeskOrGrievance/RaiseTicketMain";
import ViewRiasedTicketMain from "../Pages/DMS/HelpdeskOrGrievance/ViewRiasedTicketMain";
import SopInstance from "../Pages/DMS/SOPManagement/SopInstance/SopInstance";
import CircularsMain from "../Pages/DMS/InformationCenter/Circulars/CircularMain";
import ManageSlaMain from "../Pages/DMS/HelpdeskOrGrievance/ManageSlaMain";
import UserDetectionHeader from "../Pages/DMS/UserDetection/UserDetectionHeader";
import UserFaceHeader from "../Pages/DMS/UserRegistrationFace/UserFaceHeader";
import AccidentViewer from "../Pages/DMS/ExpectedTrackForm/AccidentViewer";
import AccidentViewerHeader from "../Pages/DMS/ExpectedTrackForm/AccidentViewerHeader";
import AccidentsHistory from "../Pages/DMS/ExpectedTrackForm/AccidentsHistoryMain";
import RealTimeCrowdMonitoringMain from "../Pages/DMS/RealTimeCrowdMonitoring/RealTimeCrowdMonitoringMain";
import FleetUserManagementHeader from "../Pages/DMS/FleetUserManagement/FleetUserManagementHeader";
import GeoFencing from "../Pages/DMS/GeoFence/GeoFencing";
import AssignGeofence from "../Pages/DMS/GeoFence/GeofenceManage";
import OTAMain from "../Pages/DMS/OTA/OTAMain";




const Router = () => {
  const [permissionArr, setPermissionArr] = useState(null);
  const [userProfile, setUserProfile] = useState(null); // Add this state
  const [profileLoaded, setProfileLoaded] = useState(false); // Add this state
  const [navigableLinks, setNavigableLinks] = useState([]);
  const { keycloak } = useKeycloak();
  // const navigate = useNavigate();

  useEffect(() => {
    if (keycloak.authenticated) {
      getPermissionList();
      addReportMenu();
      getUserProfile();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keycloak.authenticated]);

  const getPermissionList = async () => {
    var permissionArr = await getData(findPermissionsByUser);
    console.log("permissions", permissionArr)
    setPermissionArr(permissionArr);
    // Also get the sanitized navigation links
    await sanitizeMenus(permissionArr);
  };

  // Add this function from Sidebar.jsx
  const sanitizeMenus = async (permissions) => {
    try {
      let userPermissionIds = permissions.map((permission) => permission.id);

      let navLinkSanitised = navLinks.map((navItem) => {
        if (!navItem.children || navItem.children.length === 0) {
          return navItem;
        }

        const filteredChildren = navItem.children.filter((childItem) => {
          if (!childItem.allowedPermissionIds) {
            return true;
          }

          return childItem.allowedPermissionIds.some((requiredPermissionId) =>
            userPermissionIds.includes(requiredPermissionId)
          );
        });

        const processNestedChildren = (children) => {
          return children.map((child) => {
            if (!child.children || child.children.length === 0) {
              return child;
            }

            const nestedFilteredChildren = child.children.filter(
              (nestedChild) => {
                if (!nestedChild.allowedPermissionIds) {
                  return true;
                }

                return nestedChild.allowedPermissionIds.some(
                  (requiredPermissionId) =>
                    userPermissionIds.includes(requiredPermissionId)
                );
              }
            );

            return {
              ...child,
              children: processNestedChildren(nestedFilteredChildren),
            };
          });
        };

        return {
          ...navItem,
          children: processNestedChildren(filteredChildren),
        };
      });

      navLinkSanitised = navLinkSanitised.filter((navItem) => {
        if (!navItem.children || navItem.children.length === 0) {
          if (
            !navItem.allowedPermissionIds ||
            navItem.allowedPermissionIds.length === 0
          ) {
            return false;
          }
          return navItem.allowedPermissionIds.some((requiredPermissionId) =>
            userPermissionIds.includes(requiredPermissionId)
          );
        }

        return navItem.children.length > 0;
      });

      setNavigableLinks(navLinkSanitised);
    } catch (error) {
      console.error("Error sanitizing menus:", error);
      setNavigableLinks([]);
    }
  };

  // Add the getUserProfile function
  const getUserProfile = async () => {
    try {
      const userProfileData = await getData(getThemeURL);
      setUserProfile(userProfileData);
      setProfileLoaded(true);
      if (userProfileData && userProfileData.length > 0) {
        // getUserList(userProfileData[0]); // Uncomment if you need this
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
      toast.error("Failed to fetch user profile", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
      setProfileLoaded(true); // Set to true even on error to prevent infinite loading
    }
  };
  // Modified function to check if dashboard is accessible
  const isDashboardAccessible = () => {
    if (!navigableLinks || navigableLinks.length === 0) return false;

    // Check if "Dashboards" or "API Dashboards" are in the accessible menu
    const hasDashboard = navigableLinks.some(
      (item) => item.label === "Dashboards" || item.label === "API Dashboards"
    );

    return hasDashboard;
  };

  // Get the first accessible route
  const getFirstAccessibleRoute = () => {
    if (!navigableLinks || navigableLinks.length === 0) {
      return <SoPManagement />; // Fallback
    }

    const firstItem = navigableLinks[0];

    // If first item has children, get the first child's route
    if (firstItem.children && firstItem.children.length > 0) {
      const firstChild = firstItem.children[0];
      return getComponentForRoute(firstChild.to);
    }

    // If no children, use the parent route
    return getComponentForRoute(firstItem.to);
  };

  // Helper function to map routes to components
  const getComponentForRoute = (routePath) => {
    const routeMap = {
      "add-bank": <BankForm />,
      "bank-list": <BankManagement />,
      "add-branch": <BranchForm />,
      allbrancheslist: <AllBranches />,
      DistrictWiseBranches: <DistrictWiseBranchesMain />,
      "add-atms": <AddAtmForm />,
      "all-atms": <AllAtm />,
      "districtwise-atms": <DistrictWise />,
      "Gis-Map": <GisMain />,
      // 'incidents': <AllincidentsMain />,
      "create-incident": <IncidentForm />,
      All_Incidents: <AllIncidentsMain />,
      "view-sop": <SOPManagement />,
      "view-task": <TaskManagement />,
      "create-sop": <CreateSOP />,
      "execute-sops": <ExecuteSops />,
      "Sop-instance-list": <SopInstance />,
      // 'sop-management': <SoPManagement />,
      "my-tasks": <MyTaskListManagement />,
      "view-usertask": <UserTaskManagement />,
      "new-announcements": <AnnouncementsForm />,
      "document-repo": <DocumentRepoMain />,
      circulars: <CircularsMain />,
      "public-announcements": <PublicAnnoncementsMain />,
      roles: <RoleManagement />,
      users: <UserManagement />,
      "contact-management": <ContactManagement />,
      grievance: <GrievanceMain />,
      "manage-sla": <ManageSlaMain />,
      "raise-ticket": <RaiseTicketMain />,
      "view-raise-ticket": <ViewRiasedTicketMain />,
      // 'configurations': <ResourceManagement />,
      "resource-list": <ResourceManagement />,
      "region-list": <RegionManagement />,
      "exptected-route": <ExpectedTrackHeader />,
      "planned-route": <PlannedHeader />,
      "gps-tracking": <GpsTracking />,
      "AccidentViewer": <AccidentViewerHeader />

      // Add more route mappings as needed
    };

    return routeMap[routePath] || <GpsTracking />; // Default fallback
  };

  // Modified function to determine which dashboard component to render
  const getDashboardComponent = () => {
    // First check if dashboard is accessible
    if (!isDashboardAccessible()) {
      return getFirstAccessibleRoute();
    }

    // If dashboard is accessible, check user role
    if (!userProfile || userProfile.length === 0) {
      return getFirstAccessibleRoute();
    }

    const userRole = userProfile[0]?.role_name;
    if (userRole === "SUPER ADMIN" || userProfile[0]?.is_admin === true) {
      return <EnhancedDashboardManager />;
    } else {
      return <EnhancedDashboardManagerForUser />;
    }
  };
  const getConfigurationsIndexComponent = () => {
    let componentArr = {
      "35_2": <ResourceManagement />,
    };

    let data = [];
    permissionArr.forEach(function (permission) {
      if (permission.parent_id != null && permission.parent_id === 26) {
        data.push(permission);
      }
    });
    data = data.sort((a, b) => {
      if (a.menu_index < b.menu_index) {
        return -1;
      } else if (a.menu_index > b.menu_index) {
        return 1;
      } else {
        return 0;
      }
    });
    if (data.length > 0) {
      return componentArr[data[0]["id"] + "_" + data[0]["menu_index"]];
    } else {
      return null;
    }
  };
  const getPlanningIndexComponent = () => {
    let componentArr = {
      "36_3": <SoPManagement />,
    };

    let data = [];
    permissionArr.forEach(function (permission) {
      if (permission.parent_id != null && permission.parent_id === 26) {
        data.push(permission);
      }
    });
    data = data.sort((a, b) => {
      if (a.menu_index < b.menu_index) {
        return -1;
      } else if (a.menu_index > b.menu_index) {
        return 1;
      } else {
        return 0;
      }
    });
    if (data.length > 0) {
      return componentArr[data[0]["id"] + "_" + data[0]["menu_index"]];
    } else {
      return null;
    }
  };
  const addReportMenu = async () => {
    var data = await getData(getStoredFormTemplates);
    let form_viewer_links = [];
    data.forEach(function (dataElems) {
      form_viewer_links.push(dataElems.form_name);
    });
  };

  return (
    <Routes>
      {permissionArr != null && profileLoaded && (
        <Route path="/" element={<DMS />}>
          {/* <Route index element={<vehicle />} /> */}
          <Route
            index
            element={
              <PrivateRoute>
                {/* <DMSDashboard /> */}
                {getDashboardComponent()}
              </PrivateRoute>
            }
          />
          <Route
            path="/userProfile"
            element={
              <PrivateRoute>
                <UserProfile />
              </PrivateRoute>
            }
          />
          <Route
            path="static"
            element={
              <PrivateRoute>
                <MyTaskListManagement />
              </PrivateRoute>
            }
          />
          <Route path="users-management">
            <Route index element={<UserManagement />} />
            {lms_routes_regs.map(({ name, component }, i) => (
              <Route
                key={i}
                path={name}
                element={<PrivateRoute>{component}</PrivateRoute>}
              />
            ))}
          </Route>
          <Route path="Dynamic-dashboard">
            <Route index element={<QueryBuilder />} />
            {Dashboard_Dynamic.map(({ name, component }, i) => (
              <Route
                key={i}
                path={name}
                element={<PrivateRoute>{component}</PrivateRoute>}
              />
            ))}
          </Route>
          <Route path="dynamic-dashboard-api">
            <Route index element={<ApiBuilder />} />
            {Dashboard_DynamicForApi.map(({ name, component }, i) => (
              <Route
                key={i}
                path={name}
                element={<PrivateRoute>{component}</PrivateRoute>}
              />
            ))}
          </Route>
          <Route path="branches">
            <Route index element={<UserManagement />} />
            {branches_routes_regs.map(({ name, component }, i) => (
              <Route
                key={i}
                path={name}
                element={<PrivateRoute>{component}</PrivateRoute>}
              />
            ))}
          </Route>
          <Route path="incidents">
            <Route index element={<AllincidentsMain />} />
            {incidents.map(({ name, component }, i) => (
              <Route
                key={i}
                path={name}
                element={<PrivateRoute>{component}</PrivateRoute>}
              />
            ))}
          </Route>
          <Route path="branches">
            <Route index element={<UserManagement />} />
            {branches_routes_regs.map(({ name, component }, i) => (
              <Route
                key={i}
                path={name}
                element={<PrivateRoute>{component}</PrivateRoute>}
              />
            ))}
          </Route>
          <Route path="contact-management">
            <Route index element={<ContactManagement />} />
            {contact_management.map(({ name, component }, i) => (
              <Route
                key={i}
                path={name}
                element={<PrivateRoute>{component}</PrivateRoute>}
              />
            ))}
          </Route>
          <Route path="grievance">
            <Route index element={<GrievanceMain />} />
            {grievance_routes.map(({ name, component }, i) => (
              <Route
                key={i}
                path={name}
                element={<PrivateRoute>{component}</PrivateRoute>}
              />
            ))}
          </Route>
          <Route path="configurations">
            <Route index element={getConfigurationsIndexComponent()} />
            {configurations.map(({ name, component }, i) => (
              <Route
                key={i}
                path={name}
                element={<PrivateRoute>{component}</PrivateRoute>}
              />
            ))}
          </Route>
          <Route
            path="/configurations/resource-list"
            element={<RegistrationManagement />}
          >
            <Route index element={<ResourceManagement />} />
            {configurations.map(({ name, component }, i) => (
              <Route
                key={i}
                path={name}
                element={<PrivateRoute>{component}</PrivateRoute>}
              />
            ))}
          </Route>
          <Route path="incidents">
            <Route index element={getConfigurationsIndexComponent()} />
            {incidents.map(({ name, component }, i) => (
              <Route
                key={i}
                path={name}
                element={<PrivateRoute>{component}</PrivateRoute>}
              />
            ))}
          </Route>
          <Route path="dist-dashboard" element={<RegistrationManagement />}>
            <Route index element={<SoPManagement />} />
          </Route>
          <Route path="reports" element={<RegistrationManagement />}></Route>
          <Route path="RoutePlanning/create-vehicle" element={<CreateVehicleHeader />}></Route>
          <Route path="RoutePlanning/exptected-route" element={<ExpectedTrackHeader />}></Route>
          <Route path="RoutePlanning/AccidentViewer" element={<AccidentViewerHeader />}></Route>
          <Route path="RoutePlanning/planned-route" element={<PlannedHeader />}></Route>
          <Route path="RoutePlanning/trip-tracking" element={<TripTrackerHeader />}></Route>
          <Route path="RoutePlanning/planned-view" element={<PlannedViewHeader />}></Route>
          <Route path="RoutePlanning/trip-trakingView" element={<TripActionHeader />}></Route>
          <Route path="RoutePlanning/travel-view" element={<GpsTravelViewHeader />}></Route>
          <Route path="RoutePlanning/deviation-route" element={<DeviationRouteHeader />}></Route>
          <Route path="RoutePlanning/accident-history" element={<AccidentsHistory />}></Route>
          <Route path="Geofencing/createfencing" element={<GeoFencing />}></Route>
          <Route path="Geofencing/assignfencing" element={<AssignGeofence />}></Route>
          <Route path="OTA" element={<OTAMain />}>
            {OTA.map(({ name, component }, i) => (
              <Route
                key={i}
                path={name}
                element={<PrivateRoute>{component}</PrivateRoute>}
              />
            ))}
          </Route>


         

          <Route path="FaceManagement/UserDetection" element={<UserDetectionHeader />}></Route>
          <Route path="FaceManagement/UserRegistration" element={<UserFaceHeader />}></Route>
          <Route path="FaceManagement/RealTimeCrowdMonitoring" element={<RealTimeCrowdMonitoringMain />}></Route>
          <Route path="users-management/user-list" element={<PrivateRoute><FleetUserManagementHeader initialTab="list" /></PrivateRoute>}></Route>
          <Route path="FaceManagement" element={<UserDetectionHeader />}>
            {FaceManagement.map(({ name, component }, i) => (
              <Route
                key={i}
                path={name}
                element={<PrivateRoute>{component}</PrivateRoute>}
              />
            ))}
          </Route>
          <Route path="my-tasks" element={<MyTaskListManagement />}>
            <Route index element={<MyTaskListManagement />} />
            {my_tasks_regs.map(({ name, component }, i) => (
              <Route
                key={i}
                path={name}
                element={<PrivateRoute>{component}</PrivateRoute>}
              />
            ))}
          </Route>
          <Route path="dist-dashboard/incidentdashboard">
            <Route index element={<RTIncidentDashboard />} />
          </Route>
          <Route path="region-list">
            <Route index element={<RegionManagement />} />
            {region_routes_regs.map(({ name, component }, i) => (
              <Route
                key={i}
                path={name}
                element={<PrivateRoute>{component}</PrivateRoute>}
              />
            ))}
          </Route>
          <Route path="/configurations/agency-list">
            {configurations.map(({ name, component }, i) => (
              <Route
                key={i}
                path={name}
                element={<PrivateRoute>{component}</PrivateRoute>}
              />
            ))}
          </Route>
          <Route path="sop-management">
            <Route index element={getPlanningIndexComponent()} />
            {planning_routes_regs.map(({ name, component }, i) => (
              <Route
                key={i}
                path={name}
                element={<PrivateRoute>{component}</PrivateRoute>}
              />
            ))}
          </Route>
          <Route path="gismanagment">
            <Route index element={<GisMain />} />
            {my_gis_mgmnt_regs.map(({ name, component }, i) => (
              <Route
                key={i}
                path={name}
                element={<PrivateRoute>{component}</PrivateRoute>}
              />
            ))}
          </Route>
          <Route path="/my-tasks/view-usertask">
            <Route index element={<UserTaskManagement />} />
          </Route>
          <Route path="/RoutePlanning/gps-tracking">
            <Route index element={<GpsTracking />} />

            {RoutePlanning.map(({ name, component }, i) => (
              <Route
                key={i}
                path={name}
                element={<PrivateRoute>{component}</PrivateRoute>}
              />
            ))}
          </Route>
          <Route path="/my-tasks/create-usertask">
            <Route index element={<UserTaskForm />} />
          </Route>
         
          <Route path="/my-tasks/user-task-view">
            <Route index element={<UserViewmain />} />
          </Route>
          <Route path="/my-gps-tracking/gps-track-view">
            <Route index element={<GpsTrackView />} />
          </Route>
          {/* <Route path="dmsdashboard"> */}
          <Route index element={<SoPManagement />} />
          {/* </Route> */}
          <Route path="information-center">
            {information_center.map(({ name, component }, i) => (
              <Route
                key={i}
                path={name}
                element={<PrivateRoute>{component}</PrivateRoute>}
              />
            ))}
          </Route>
          <Route path="add-atm">
            {add_atm.map(({ name, component }, i) => (
              <Route
                key={i}
                path={name}
                element={<PrivateRoute>{component}</PrivateRoute>}
              />
            ))}
          </Route>
        </Route>
      )}
    </Routes>
  );
};
export default Router;
